<template>
  <v-container>
    <v-card class="pad-10" flat>
      <v-container>
        <v-row style="padding: 12px">
          <div>
            <h2>Statistics</h2>
          </div>
          <v-spacer></v-spacer>
          <div>
            <p>dropdown</p>
          </div>
        </v-row>
        <graph :styles="myStyles" />
        <v-btn @click="increase()">
            <v-icon>
                mdi-plus
            </v-icon>
        </v-btn>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Graph from "../components/graph.js";
export default {
  components: {
    Graph,
  },
  data () {
    return {
      height: 500
    }
  },
  methods: {
    increase() {
      this.height += 10;
    },
  },
  computed: {
    myStyles() {
      return {
        height: `${this.height}px`,
        position: "relative",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";
h2{
  color:$Dtunes-text;
}
</style>